<template>
  <v-menu offset-y right>
    <template v-slot:activator="{ on }">
      <v-btn text v-on="on">
        <v-icon color="secondary" v-text="icons.mdiFormatListCheckbox"></v-icon>
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item href="#" @click="csvButtonClicked">
        <v-list-item-icon class="mr-3">
          <v-icon :color="exportLinks[2].color" v-text="exportLinks[2].icon"></v-icon>
        </v-list-item-icon>
        <v-list-item-title>
          <span v-if="exportStatus === 1">
            {{ exportBtnTitle[lang] }}
          </span>
          <v-progress-circular
            v-if="exportStatus === 2"
            :size="20"
            color="primary"
            indeterminate
          ></v-progress-circular>
          <div v-if="exportStatus === 3" class="d-flex">
            <div>
              <a :href="exportFile?.url" target="_blank">
                {{ downloadBtnTitle[lang] }}
              </a>
              <div>
                {{ lastExport[lang] + (exportFile?.created_at || '') }}
              </div>
            </div>
            <v-icon
              v-text="icons.mdiDelete"
              color="red"
              @click.stop="deleteCSV(exportKey)"
              class="ml-2"
            ></v-icon>
          </div>
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import {
  mdiFormatListCheckbox,
  mdiMicrosoftExcel,
  mdiFilePdf,
  mdiFileDelimitedOutline,
  mdiDelete,
} from '@mdi/js';
import { mapState, mapActions } from 'vuex';

export default {
  name: 'ExportLinks',
  props: {
    exportKey: { type: String, required: true },
    query: { type: String, required: false, default: '' },
    filters: { type: Object, default: () => ({}) },
    exportBtnTitle: {
      default: () => ({
        el: 'Λήψη αρχείου CSV',
        en: 'Export to CSV file',
        it: 'Esportazione in file CSV',
      }),
      type: Object,
    },
    downloadBtnTitle: {
      default: () => ({
        el: 'Λήψη αρχείου CSV',
        en: 'Download CSV file',
        it: 'Scarica il file CSV',
      }),
      type: Object,
    },
  },
  data: () => ({
    icons: { mdiFormatListCheckbox, mdiDelete },
    exportLinks: [
      {
        icon: mdiMicrosoftExcel,
        text: {
          el: 'Λήψη αρχείου Excel',
          en: 'Export to Excel',
          it: 'Esporta in Excel',
        },
        color: 'green darken-3',
      },
      {
        icon: mdiFilePdf,
        text: { el: '', en: 'Export to PDF', it: '' },
        color: 'red darken-4',
      },
      {
        icon: mdiFileDelimitedOutline,
        text: {
          el: 'Λήψη αρχείου CSV',
          en: 'Export to CSV',
          it: 'Esporta in CSV',
        },
        color: 'blue darken-3',
      },
    ],
    lastExport: {
      el: 'Τελευταία Έκδοση: ',
      en: 'Last Export: ',
      it: 'Ultima Esportazion: ',
    },
  }),
  computed: {
    ...mapState('exportLinks', ['exportsData']),
    lang() {
      return this.$route.params.lang || 'en';
    },
    exportStatus() {
      return this.exportsData[this.exportKey]?.status || 1;
    },
    exportFile() {
      return this.exportsData[this.exportKey]?.file || null;
    },
  },
  methods: {
    ...mapActions('exportLinks', [
      'deleteCSV',
      'exportCSV',
      'fetchExportedFile',
      'handleExportStatus',
    ]),
    csvButtonClicked() {
      if (this.exportStatus === 1) {
        this.exportCSV({ key: this.exportKey, query: this.query, filters: this.filters });
      }
    },
  },
  watch: {
    exportKey: {
      immediate: true,
      handler(newKey) {
        if (newKey) {
          this.fetchExportedFile({ key: newKey });
        }
      },
    },
  },
};
</script>
